import { Injectable, Injector } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { InstrumentDefinitie } from '../dto/instrument-definitie';
import { CrudService, Filter, FilterOperator } from '@mango/core';
import { DocumentDownloadResponse } from './projectregel.service';
import { map } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class InstrumentDefinitieService extends CrudService<InstrumentDefinitie> {

    constructor(injector: Injector) { super(InstrumentDefinitie, injector); }

    downloadExcelFile(filter: Filter<InstrumentDefinitie>) {
        
        let f = `filter=${encodeURIComponent(JSON.stringify(this.convertFilter(filter) ))}`;
        let query: string = `/api/dto/instrument/InstrumentDefinitieExport?${f}`;

        return this.http.post(query, null).pipe(map(x => x as DocumentDownloadResponse));

    }

    kopieren(instrumentdefinitie: InstrumentDefinitie) {
        let query: string = `api/dto/instrument/kopierenPrijsregel?Id=${instrumentdefinitie.id}`;

        return this.http.post(query, null).pipe(map(x => x as InstrumentDefinitieResponse));

    }  


    private convertFilter (f: Filter<InstrumentDefinitie>, arr: any[] = [] ) {
        for(let fp of f.getProperties()) {
            arr.push(fp);
        };

        let isEmpty = (str)=>typeof(str)=='string' && str.trim() == "";

        Object.keys(f).forEach(x => {
            if(Object.keys(new Filter<InstrumentDefinitie>()).indexOf(x) === -1 && f[x] != null && !isEmpty(f[x])) {
                let customProperty = {};
                customProperty[x] = f[x];
                arr.push(customProperty);
            }
        });

        f.filters.forEach(subF => {
            let andOrItem = {};
            let subArr = [];
            this.convertFilter(subF, subArr);
            andOrItem[subF.filterOperator == FilterOperator.And ? "and" : "or"] = subArr;
            arr.push(andOrItem);
        });

        return arr;
    }
    
}

export class InstrumentDefinitieResponse {
    successful: boolean;
    newId: number;
}